'use client';

import { Search } from '@mui/icons-material';
import { TextField } from '@/ui/kit/components/textfield';
type FaqSearchBarProps = {
  value: string;
  onChange: (value: string) => void;
  resultCount?: number;
};
export default function FaqSearchBar({
  value,
  onChange,
  resultCount
}: FaqSearchBarProps) {
  return <TextField fullWidth variant='fill' placeholder='جستجو در پرسش‌ها...' value={value} onChange={event => onChange(event.target.value)} startIcon={<Search sx={{
    color: 'text.text3'
  }} />} helperText={value.trim() && resultCount !== undefined ? `${resultCount} نتیجه یافت شد` : undefined} data-sentry-element="TextField" data-sentry-component="FaqSearchBar" data-sentry-source-file="FaqSearchBar.tsx" />;
}